import { Modal, ModalContent } from 'telia-front-react';
import { observer } from 'mobx-react';
import React from 'react';
import useStores from '../stores/UseStores';
import ForgotPassword from '../components/ForgotPassword';

const ForgotPasswordModal = observer((): React.JSX.Element => {
  const {
    forgotPasswordStore: { forgotPasswordModalOpen, setForgotPasswordModalState },
  } = useStores();

  return (
    <Modal
      isOpen={forgotPasswordModalOpen}
      onClose={() => setForgotPasswordModalState(false)}
      hasContentComponent={true}
      size="6-col"
      aria-labelledby="forgot-password-modal-title"
      initialFocusedElementId="confirm-button"
    >
      <ModalContent>
        <ForgotPassword inModal={true} readOnly={true} />
      </ModalContent>
    </Modal>
  );
});

export default ForgotPasswordModal;
